import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import config from "config";

import Hubly from "scenes/Hubly";
import HubSelector from "scenes/Hubly/components/Workflows/components/HubSelector";
import Layout from "scenes/Hubly/Layout";

function HublyRoutes() {
  const { path } = useRouteMatch();

  return (
    <Layout>
      <Switch>
        <Route exact path={path}>
          <HubSelector />
        </Route>
        <Route
          exact
          component={Hubly}
          path={[
            `${path}/:hubId`,
            `${path}/:hubId/tools`,
            `${path}/:hubId/settings`,
            `${path}/:hubId/settings/:settingsPage`,
            `${path}/:hubId/${config.privacyMode?.enableKeyword || "privacy"}`,
            `${path}/:hubId/clients/:clientId`,
            `${path}/:hubId/clients/:clientId/workflows`,
            `${path}/:hubId/clients/:clientId/workflows/:workflowId`,
            `${path}/:hubId/clients/:clientId/notes`,
            `${path}/:hubId/clients/:clientId/history`,
            `${path}/:hubId/clients/:clientId/attachments`,
            `${path}/:hubId/workdesk`,
            `${path}/:hubId/workdesk/clients/:clientId`,
            `${path}/:hubId/workdesk/clients/:clientId/workflows`,
            `${path}/:hubId/workdesk/clients/:clientId/workflows/:workflowId`,
            `${path}/:hubId/workdesk/clients/:clientId/notes`,
            `${path}/:hubId/workdesk/clients/:clientId/history`,
            `${path}/:hubId/workdesk/clients/:clientId/attachments`,
            `${path}/:hubId/templates/:section`,
            `${path}/:hubId/welcome/form`,
            `${path}/:hubId/welcome/booking`,
            `${path}/:hubId/welcome/education`,
          ]}
        />

        <Redirect
          from={`${path}/:hubId/templates`}
          to={`${path}/:hubId/templates/all`}
        />

        <Redirect to={path} />
      </Switch>
    </Layout>
  );
}

HublyRoutes.propTypes = {};

HublyRoutes.defaultProps = {};

export default HublyRoutes;
